// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__Urg8a","title":"FrontImage_title__fWeK4"};